import Header from "@/components/Header";
import Hero from "@/components/Hero";
import CryptoTicker from "@/components/CryptoTicker";
import HoldingsWidget from "@/components/HoldingsWidget";
import TournamentRail from "@/components/TournamentRail";
import LiveStats from "@/components/LiveStats";
import AboutArena from "@/components/AboutArena";
import PresaleWidget from "@/components/PresaleWidget";
import Tokenomics from "@/components/Tokenomics";
import HowItWorks from "@/components/HowItWorks";
import Roadmap from "@/components/Roadmap";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

/**
 * Home is now a pure layout — wallet, balance, tier and eligibility live in the
 * ArcEcosystemProvider. Components consume the hooks they need directly.
 */
export default function Home() {
  return (
    <div className="relative min-h-screen bg-[#050505] text-white" data-testid="home-page">
      <Header />
      <Hero />
      <CryptoTicker />
      <HoldingsWidget />
      <TournamentRail />
      <LiveStats />
      <AboutArena />
      <PresaleWidget />
      <Tokenomics />
      <HowItWorks />
      <Roadmap />
      <FAQ />
      <Footer />
    </div>
  );
}
